import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { loadStoreCallVisitGetRequest, loadStoreCallVisitSendMailPostRequest } from "../redux/Actions";
import DefaultButton from "../../../shared/components/DefaultButton";

const StoreVisitTab = ({ storeSap }) => {
  const dispatch = useDispatch();
  const { storevisits: rawVisits, storevisitsLoading, storevisitsError } = useSelector(
    (state) => state.searchsap
  );

  const storevisits = Array.isArray(rawVisits)
    ? rawVisits
    : Array.isArray(rawVisits?.data)
    ? rawVisits.data
    : [];

  useEffect(() => {
    dispatch(loadStoreCallVisitGetRequest({ store_location_id: storeSap }));
  }, [dispatch]);

  const isTodayOrFuture = (eventDate) => {
    if (!eventDate) return false;
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    const visitDate = new Date(eventDate);
    visitDate.setHours(0, 0, 0, 0);
    return visitDate >= today;
  };

  const handleSendNotification = (id) => {
    dispatch(loadStoreCallVisitSendMailPostRequest({ store_visit_id: id }));
  };

  if (storevisitsLoading) {
    return (
      <div className="d-flex justify-content-center align-items-center py-5">
        <div className="spinner-border text-primary" role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
      </div>
    );
  }

  if (storevisitsError) {
    return (
      <div className="alert alert-danger mt-3" role="alert">
        {storevisitsError?.msg || "Failed to load store visits."}
      </div>
    );
  }

  if (!storevisits || storevisits.length === 0) {
    return (
      <div className="text-center text-muted py-5">
        No store visits found for this location.
      </div>
    );
  }

  return (
    <div className="table-responsive mt-2">
      <table className="table table-striped table-bordered table-hover table-sm">
        <thead className="table-secondary">
          <tr>
            <th>Name</th>
            <th>Ticket ID</th>
            <th style={{ whiteSpace: "nowrap" }}>Event Type</th>
            <th>Vendor</th>
            <th style={{ whiteSpace: "nowrap" }}>Tracking URL</th>
            <th style={{ whiteSpace: "nowrap" }}>Event Date</th>
            <th>Status</th>
            <th>Store</th>
            <th>Description</th>
            <th>Action</th>
          </tr>
        </thead>
        <tbody>
          {storevisits.map((row) => {
            const location = row.locations?.[0];
            const canNotify = isTodayOrFuture(row.event_date);
            return (
              <tr key={row.id} style={{ lineHeight: "2.2" }}>
                <td>{row.name ?? "-"}</td>
                <td>{row.ticket_id ? (<a href={`/ticketing/${row.ticket_id}`}>{row.ticket_number ?? "-"}</a>) : (row.ticket_number ?? "-")}</td>
                <td style={{ whiteSpace: "nowrap" }}>{row.event_type ?? "-"}</td>
                <td>{row.vendor_id ?? "-"}</td>
                <td>
                  {row.tracking_url ? (
                    <a href={row.tracking_url} target="_blank" rel="noreferrer">Track</a>
                  ) : "-"}
                </td>
                <td style={{ whiteSpace: "nowrap" }}>{row.event_date ?? "-"}</td>
                <td>
                  <span
                    className={`badge ${
                      row.status?.toLowerCase() === "completed"
                        ? "bg-success"
                        : row.status?.toLowerCase() === "pending"
                        ? "bg-warning text-dark"
                        : "bg-secondary"
                    }`}
                  >
                    {row.status ?? "-"}
                  </span>
                </td>
                <td>
                  {location ? `${location.store_sap} - ${location.store_name}` : "-"}
                </td>
                <td>{row.description ?? "-"}</td>
                <td>                 
                    <DefaultButton
                      buttonClass="default-btn-color btn-sm"
                      buttonTitle={
                        <>
                          <i className="bx bx-bell me-1"></i>
                          Send Notification
                        </>
                      }
                      actionBlock={() => handleSendNotification(row.id)}
                      disabled={!canNotify}
                    />                  
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};

export default StoreVisitTab;